module.exports = __webpack_public_path__ + "img/mindfire_logo.6113fc6b.png";